import React from "react";
import { IoIosArrowBack } from "react-icons/io";

export default function BackButton({ onClick }) {
  return (
    <div
      onClick={onClick}
      className="text-lg py-4 flex items-center gap-3 cursor-pointer"
    >
      <IoIosArrowBack /> Back
    </div>
  );
}
